document.addEventListener('DOMContentLoaded', function () {
    // Initialize Slick slider
    const slickOptions = {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      centerMode: true,
      focusOnSelect: true,
      dots: true, // Enable dots for navigation
      arrows: false, // Remove arrows
      autoplay: true, // Enable autoplay
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true, // Ensure dots are enabled in responsive views
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 370,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
  
    // Initialize the Slick slider on the element
    const slider = document.querySelector('.follow-insta-slider');
    if (slider) {
      $(slider).slick(slickOptions);
    }
  });
  
  
  document.addEventListener("DOMContentLoaded", function () {
    const benefitsSliders = document.querySelectorAll(".benefits-slider");  // Use a class instead of ID
  
    benefitsSliders.forEach(function(benefitsSlider) {
      let isSlickInitialized = false;
  
      function initializeSlider() {
        if (window.innerWidth < 768) {
          if (!isSlickInitialized) {
            $(benefitsSlider).slick({
              dots: true,             // Enable dots navigation
              arrows: false,          // Disable arrows
              infinite: true,         // Enable infinite scrolling
              speed: 300,             // Slide speed
              slidesToShow: 1,        // Show 1 slide at a time
              slidesToScroll: 1,      // Scroll 1 slide at a time
              autoplay: true,         // Enable autoplay
              autoplaySpeed: 2000,    // Set autoplay speed (2 seconds)
            });
            isSlickInitialized = true;
          }
        } else {
          if (isSlickInitialized) {
            $(benefitsSlider).slick("unslick");
            isSlickInitialized = false;
          }
        }
      }
  
      // Initialize on load
      initializeSlider();
  
      // Re-initialize on window resize
      window.addEventListener("resize", initializeSlider);
    });
  });
  
  
  document.addEventListener('DOMContentLoaded', function () {
    // Get all the anchor tags
    const links = document.querySelectorAll('.start-training-btn-holder a');
  
    // Get the current URL
    const currentUrl = window.location.href;
  
    // Loop through the links and check if the href matches the current URL
    links.forEach(link => {
      if (currentUrl.includes(link.getAttribute('href'))) {
        link.classList.add('active');  // Add active class if it matches
      }
    });
  });
  
  
  document.addEventListener("DOMContentLoaded", function() {
    // Select all metafield containers
    const metafieldContainers = document.querySelectorAll('.metafield-data');
  
    // Iterate through each metafield container
    metafieldContainers.forEach(function(container) {
      const productId = container.getAttribute('data-product-id');
      
      // Create a temporary DOM element to parse the metafield HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = container.innerHTML;
  
      // Extract the list items or data from the metafield
      const listItems = tempDiv.querySelectorAll('li');
  
      // Select the corresponding swiper slides in the popup for this product
      const swiperSlides = document.querySelectorAll(`[data-popup-id="${productId}"] .swiper-slide`);
  
      // Check if the number of list items matches the number of slides
      if (listItems.length !== swiperSlides.length) {
        console.warn(`Mismatch: ${listItems.length} list items for ${swiperSlides.length} slides.`);
      }
  
      // Iterate over each slide and assign the corresponding metafield data
      swiperSlides.forEach((slide, index) => {
        const descriptionContainer = slide.querySelector('.slide-description');
        if (descriptionContainer && listItems[index]) {
          const ul = document.createElement('ul');
          const li = listItems[index].cloneNode(true); // Clone to preserve the original node
          ul.appendChild(li);
          descriptionContainer.appendChild(ul);
        } else {
          console.warn(`No matching list item for slide index ${index}.`);
        }
      });
  
      // Optionally remove the original metafield container to clean up the DOM
      container.parentNode.removeChild(container);
    });
  });
  
  
  
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('contactForm');
    const successMessage = document.getElementById('successMessage');

    if(form){
    form.addEventListener('submit', function (event) {
      // Prevent the form from reloading the page (only for demo; in real cases, let Shopify handle it)
      event.preventDefault();
  
      // Show the success message
      successMessage.classList.remove('hidden');
  
      // Hide the message after 2 seconds
      setTimeout(() => {
        successMessage.classList.add('hidden');
      }, 2000);
    });
    }
  });
  
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.custom-contact-form');
    const successMessage = document.getElementById('successMessage');

    if(form){
    form.addEventListener('submit', function (event) {
      // Prevent the form from reloading the page (only for demo; in real cases, let Shopify handle it)
      event.preventDefault();
  
      // Show the success message
      successMessage.classList.remove('hidden');
  
      // Hide the message after 2 seconds
      setTimeout(() => {
        successMessage.classList.add('hidden');
      }, 2000);
    });
    }
  });
  
  document.querySelectorAll('.product-detail-box ul').forEach(ul => {
    ul.querySelectorAll('li').forEach(li => {
      const span = document.createElement('span');
      span.classList.add('list-style-image'); // Add the desired class to the span
      li.insertBefore(span, li.firstChild); // Insert span before the first child (li content)
    });
  });
  
   window.onload = function () {
      $(".product-content-varient-title-block").on("click", function () {
          const $dropdown = $(this).siblings(".product-content-varient-dropdown");
  
          if ($dropdown.hasClass("hidden")) {
              $dropdown
                  .removeClass("hidden")
                  .slideDown(); // Animate the dropdown
          } else {
              $dropdown
                  .slideUp(function () {
                      $(this).addClass("hidden"); // Add class after animation
                  });
          }
      });
  };
  
  
  document.addEventListener("DOMContentLoaded", function () {
    
    const variantBlocks = document.querySelectorAll(".product-content-variant-title, .product-content-colors-varient");
    const submitButton = document.querySelector(".product-btn");
    const variantInput = document.getElementById("variant-id");
    const toilet1 = document.querySelector(".toilet1");
    const toilet2 = document.querySelector(".toilet2");
    const payInstallmentsLink = document.querySelector(".Pay-installments");
    const colorVariantName = document.querySelector(".color-variant-name");
    // const productPrices = document.querySelectorAll(".product-price");
    const productPrices_discount = document.querySelectorAll(".product-price .discounted-price");
    const productPrices_compare = document.querySelectorAll(".product-price .original-price");

    //Ak custom code
     const selected_var = document.querySelector('.product-content-colors-varient.selected');
    if(selected_var){
      submitButton.removeAttribute("disabled");
      submitButton.style.opacity = "1";
        const variantId = selected_var.getAttribute("variant-id");
        selected_var.click();
    }
    //End Ak custom code
  
    const elongatedVariantIds = ["45921362641111", "45961935061207"];
    const roundVariantIds = ["45921362673879", "45961935093975"];
    const targetProductId = "8784752476375"; // Target product ID
  
    if (!variantBlocks || !submitButton || !variantInput) return;
  
    const handleVariantSelection = (variantId, variantBlock = null) => {
      console.log('vv',variantId)
      variantInput.value = variantId;
  
      if (payInstallmentsLink) {
        payInstallmentsLink.setAttribute("variant-id", variantId);
      }
  
      variantBlocks.forEach((el) => el.classList.remove("selected"));
      if (variantBlock) {
        variantBlock.classList.add("selected");
  
        // const variantTitle = variantBlock.querySelector("span.hidden:not(.var-price)")?.textContent || "";
        const variantTitle = variantBlock.getAttribute('data-title') || "";
        if (colorVariantName) {
          colorVariantName.textContent = variantTitle;
        }
  
        const variantPrice = variantBlock.querySelector(".var-price")?.textContent || "";
        const variantcomparePrice = variantBlock.querySelector(".var-compare-price")?.textContent || "";


        // if (productPrice) {
        //   productPrice.textContent = variantPrice;
        // }
        if (productPrices_discount.length) {
          productPrices_discount.forEach(function(pro_price){
            pro_price.textContent = variantPrice;
          });
        }

        if(productPrices_compare.length){
          productPrices_compare.forEach(function(pro_price){
            pro_price.textContent = variantcomparePrice;
          });
        }
      }
  
      console.log('avail',variantBlock.getAttribute('data-avail'))
      if(variantBlock.getAttribute('data-avail') == 'false')
      {
      // console.log('hhhhh')
         submitButton.setAttribute("disabled","disabled");
         submitButton.style.opacity = "0.7";
         submitButton.style.pointerEvents = "none";
         submitButton.querySelector('span').textContent = "Sold Out";
      }else{
        submitButton.removeAttribute("disabled");
        submitButton.style.opacity = "1";
        submitButton.style.pointerEvents = "auto";
        submitButton.querySelector('span').textContent = "Add To Cart";
      }

  
      // Fetch variant image from the variant block and update variant_data_img_src
      const variantImage = variantBlock.querySelector(".variant-image");
      if (variantImage) {
        const variantImgSrc = variantImage.getAttribute("src");
  
        if (elongatedVariantIds.includes(variantId)) {
          toilet1.setAttribute("variant_data_img_src", variantImgSrc);  // Only update variant_data_img_src
          toilet2.removeAttribute("variant_data_img_src");
        } else if (roundVariantIds.includes(variantId)) {
          toilet2.setAttribute("variant_data_img_src", variantImgSrc);  // Only update variant_data_img_src
          toilet1.removeAttribute("variant_data_img_src");
        } else {
          toilet1.removeAttribute("variant_data_img_src");
          toilet2.removeAttribute("variant_data_img_src");
        }
      }
  
      if (elongatedVariantIds.includes(variantId)) {
        toilet1.classList.add("active");
        toilet2.classList.remove("active");
      } else if (roundVariantIds.includes(variantId)) {
        toilet2.classList.add("active");
        toilet1.classList.remove("active");
      } else {
        toilet1.classList.remove("active");
        toilet2.classList.remove("active");
      }
    };
  
    document.querySelector(".product-content").addEventListener("click", function (event) {
      if (event.target.closest(".product-content-variant-title, .product-content-colors-varient")) {
        const block = event.target.closest(".product-content-variant-title, .product-content-colors-varient");
        const variantId = block.getAttribute("variant-id");
        handleVariantSelection(variantId, block);
      }
    });
  
    if (toilet1 && toilet2) {
      toilet1.addEventListener("click", function () {
        const toilet1VariantBlock = document.querySelector(
          `[variant-id='${elongatedVariantIds[0]}'], [variant-id='${elongatedVariantIds[1]}']`
        );
        if (toilet1VariantBlock) {
          handleVariantSelection(toilet1VariantBlock.getAttribute("variant-id"), toilet1VariantBlock);
        }
      });
  
      toilet2.addEventListener("click", function () {
        const toilet2VariantBlock = document.querySelector(
          `[variant-id='${roundVariantIds[0]}'], [variant-id='${roundVariantIds[1]}']`
        );
        if (toilet2VariantBlock) {
          handleVariantSelection(toilet2VariantBlock.getAttribute("variant-id"), toilet2VariantBlock);
        }
      });
    }
  
    // Automatically select the first variant if the product ID matches
    const productElement = document.querySelector(".product-info-block");
    const productClass = productElement?.classList?.value || "";
  
    if (productClass.includes(targetProductId)) {
      const firstVariantBlock = document.querySelector(".product-content-variant-title, .product-content-colors-varient");
      if (firstVariantBlock) {
        const firstVariantId = firstVariantBlock.getAttribute("variant-id");
        handleVariantSelection(firstVariantId, firstVariantBlock);
      }
    }
  });
  
  
  
  document.addEventListener('DOMContentLoaded', function () {
    const variantElements = document.querySelectorAll(
      '.st-cat-shop-item-detail-content-variants, .st-cat-shop-item-detail-content-colors-varient'
    );
    const variantIdInputs = document.querySelectorAll('.variant-id');
    const variantTitleSpans = document.querySelectorAll('.variant-title');
    const buttons = document.querySelectorAll('.st-cat-shop-item-detail-content .product-btn');
    const toilet1 = document.querySelector(".popup-toilet1");
    const toilet2 = document.querySelector(".popup-toilet2");
    const elongatedVariantId = "45961935061207";
    const roundVariantId = "45961935093975";
  
    if (variantIdInputs.length === 0) {
      return;
    }
  
    const selectVariant = (variantId, popupId, variantTitle, variantPrice, isColorVariant) => {
      variantIdInputs.forEach(function (input) {
        if (input.closest('[data-popup-id]').getAttribute('data-popup-id') === popupId) {
          input.value = variantId;
        }
      });
  
      // Only update the `.variant-title` for `.st-cat-shop-item-detail-content-colors-varient`
      if (isColorVariant) {
        variantTitleSpans.forEach(function (titleSpan) {
          if (titleSpan.closest('[data-popup-id]').getAttribute('data-popup-id') === popupId) {
            titleSpan.textContent = variantTitle;
          }
        });
      }
  
      const itemPriceSpans = document.querySelectorAll('.item-price');
      itemPriceSpans.forEach(function (priceSpan) {
        if (priceSpan.closest('[data-popup-id]').getAttribute('data-popup-id') === popupId) {
          priceSpan.textContent = variantPrice;
        }
      });
  
      variantElements.forEach(function (el) {
        if (el.closest('[data-popup-id]').getAttribute('data-popup-id') === popupId) {
          el.style.opacity = '0.7';
          el.classList.remove('selected');
        }
      });
  
      if (variantId) {
        variantElements.forEach(function (el) {
          if (
            el.getAttribute('data-variant-id') === variantId &&
            el.closest('[data-popup-id]').getAttribute('data-popup-id') === popupId
          ) {
            el.style.opacity = '1';
            el.classList.add('selected');
          }
        });
  
        buttons.forEach(function (btn) {
          if (btn.closest('[data-popup-id]').getAttribute('data-popup-id') === popupId) {
            btn.removeAttribute('disabled');
            btn.style.opacity = '1';
          }
        });
      }
    };
  
    variantElements.forEach(function (variantElement) {
      variantElement.addEventListener('click', function () {
        const selectedVariantId = variantElement.getAttribute('data-variant-id');
        const popupId = variantElement.closest('[data-popup-id]').getAttribute('data-popup-id');
        const selectedVariantTitle = variantElement.querySelector('.hidden.item-varient-title').textContent.trim();
        const selectedVariantPrice = variantElement.querySelector('.hidden.items-variant-price').textContent.trim();
  
        // Check if the clicked variant element is a color variant
        const isColorVariant = variantElement.classList.contains('st-cat-shop-item-detail-content-colors-varient');

        console.log('selectedVariantPrice',selectedVariantPrice);
  
        selectVariant(selectedVariantId, popupId, selectedVariantTitle, selectedVariantPrice, isColorVariant);

        const submitButton = variantElement.closest('.st-cat-shop-item-detail-content').querySelector(".product-btn");
        console.log('avail',variantElement.getAttribute('data-avail'))
        if(variantElement.getAttribute('data-avail') == 'false')
        {
        // console.log('hhhhh')
          submitButton.setAttribute("disabled","disabled");
          submitButton.style.opacity = "0.7";
          submitButton.style.pointerEvents = "none";
          submitButton.querySelector('span').textContent = "Sold Out";
        }else{
          submitButton.removeAttribute("disabled");
          submitButton.style.opacity = "1";
          submitButton.style.pointerEvents = "auto";
          submitButton.querySelector('span').textContent = "Add To Cart";
        }
  
        if (selectedVariantId === elongatedVariantId) {
          toilet1.classList.add("active");
          toilet2.classList.remove("active");
        } else if (selectedVariantId === roundVariantId) {
          toilet2.classList.add("active");
          toilet1.classList.remove("active");
        } else {
          toilet1.classList.remove("active");
          toilet2.classList.remove("active");
        }
      });
    });
  });
  
  
  
  
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize the Swiper instance
    let itemSliders = {};
  
    // Initialize Swipers for each popup (if multiple)
    document.querySelectorAll('.st-cat-shop-item-slider').forEach((slider, index) => {
      const sliderId = `swiper-${index}`;
      slider.setAttribute('data-slider-id', sliderId);
      itemSliders[sliderId] = new Swiper(slider, {
        loop: false,
        navigation: {
          nextEl: slider.closest('.st-cat-shop-item-detail-popup').querySelector('.st-cat-shop-item-next'),
          prevEl: slider.closest('.st-cat-shop-item-detail-popup').querySelector('.st-cat-shop-item-prev'),
        },
        slidesPerView: 1,
        spaceBetween: 10,
      });
    });
  
    // Monitor variant selection
    document.querySelectorAll('.st-cat-shop-item-detail-content-colors-varient, .st-cat-shop-item-detail-content-variants').forEach(variant => {
      variant.addEventListener('click', function () {
        // Get the variant image filename
        const variantImage = this.querySelector('.variant-image');
        if (!variantImage) return; // If no image is associated, exit
  
        const variantSrc = variantImage.getAttribute('src');
        const variantFilename = variantSrc.split('/').pop(); // Extract the filename
  
        const popup = this.closest('.st-cat-shop-item-detail-popup');
  
        // Get the associated Swiper instance
        const sliderElement = popup.querySelector('.st-cat-shop-item-slider');
        const sliderId = sliderElement.getAttribute('data-slider-id');
        const swiperInstance = itemSliders[sliderId];
  
        // Find the matching slide
        const slides = popup.querySelectorAll('.swiper-slide img');
        slides.forEach((slide, index) => {
          const slideSrc = slide.getAttribute('src').split('/').pop(); // Extract the filename
          if (slideSrc.startsWith(variantFilename)) { // Match by filename
            swiperInstance.slideTo(index); // Activate the matching slide
          }
        });
      });
    });
  });
  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Attach click event to all the Quick Shop buttons
    const quickShopButtons = document.querySelectorAll('.qs-btn');
    
    quickShopButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Get the product ID from the button's data-popup-id attribute
        const productId = button.getAttribute('data-popup-id');
        
        // Find the corresponding popup by matching product ID
        const popup = document.querySelector(`.st-cat-shop-item-detail-popup[data-popup-id="${productId}"]`);
  
        if (popup) {
          // Toggle the 'hidden' class to show/hide the popup
          popup.classList.toggle('hidden');
          
          // If the popup is visible, disable scrolling by setting overflow-y: hidden
          if (!popup.classList.contains('hidden')) {
            document.documentElement.style.overflowY = 'hidden';
          } else {
            // If the popup is hidden, restore scrolling
            document.documentElement.style.overflowY = '';
          }
        }
      });
    });
  
    // Attach click event to all the Close buttons
    const closeButtons = document.querySelectorAll('.st-cat-shop-item-detail-popup-close-btn, .close-popup, .close-popup2');
    
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Find the closest popup element to this close button
        const popup = button.closest('.st-cat-shop-item-detail-popup');
        
        if (popup) {
          // Hide the popup by adding the 'hidden' class
          popup.classList.add('hidden');
          
          // Restore scrolling by removing overflow-y: hidden
          document.documentElement.style.overflowY = '';
        }
      });
    });
  });
  
  
  
  document.addEventListener("DOMContentLoaded", function () {
    const sliderContainer = document.querySelector(".part-in-system-sec .d-flex");
  
    // Function to initialize the Slick slider
    function initializeSlick() {
      if ($(window).width() <= 820 && !$(sliderContainer).hasClass("slick-initialized")) {
        $(sliderContainer).slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          mobileFirst: true,
          autoplay: true, // Enable autoplay
          autoplaySpeed: 2500, // Adjust autoplay speed (in milliseconds)
        });
  
        // Add space between slides using margin-right
        $(sliderContainer).find('.slick-slide').css('margin-right', '5px'); // Adjust the space as needed
      }
    }
  
    // Function to destroy the Slick slider
    function destroySlick() {
      if ($(window).width() > 820 && $(sliderContainer).hasClass("slick-initialized")) {
        $(sliderContainer).slick("unslick");
      }
    }
  
    // Initialize or destroy Slick based on the screen size
    initializeSlick();
    window.addEventListener("resize", function () {
      initializeSlick();
      destroySlick();
    });
  });
  
  
  function applyTallestHeightToReviews() {
      // Select all elements with the class 'customer-review-block'
      const reviewBlocks = document.querySelectorAll('.customer-review-block');
  
      if (reviewBlocks.length === 0) return; // Exit if no elements are found
  
      // Get the tallest height among the elements
      let tallestHeight = 0;
      reviewBlocks.forEach(block => {
          const blockHeight = block.offsetHeight; // Get the current height
          if (blockHeight > tallestHeight) {
              tallestHeight = blockHeight; // Update the tallest height
          }
      });
  
      // Apply the tallest height to all elements
      reviewBlocks.forEach(block => {
          block.style.height = `${tallestHeight}px`;
      });
  }
  
  // Run the function after the page loads to ensure all elements are rendered
  window.addEventListener('load', applyTallestHeightToReviews);
  
  
  function setEqualHeightForPartsBlocks() {
      // Check if the screen width is below 768px
      if (window.innerWidth >= 768) return;
  
      // Select all elements with the class 'index-parts-block' and 'slick-slide'
      const partsBlocks = document.querySelectorAll('.index-parts-block.slick-slide');
  
      if (partsBlocks.length === 0) return; // Exit if no elements are found
  
      // Get the tallest height among the elements
      let tallestHeight = 0;
      partsBlocks.forEach(block => {
          const blockHeight = block.offsetHeight; // Get the current height
          if (blockHeight > tallestHeight) {
              tallestHeight = blockHeight; // Update the tallest height
          }
      });
  
      // Apply the tallest height to all elements
      partsBlocks.forEach(block => {
          block.style.height = `${tallestHeight}px`;
      });
  }
  
  // Run the function after the page loads to ensure all elements are rendered
  window.addEventListener('load', setEqualHeightForPartsBlocks);
  
  // Optional: Reapply when the window is resized
  window.addEventListener('resize', setEqualHeightForPartsBlocks);
  
  
  
  
  document.addEventListener('DOMContentLoaded', function () {
    const videoContainers = document.querySelectorAll('.cat-videos');
  
    videoContainers.forEach(container => {
      const video = container.querySelector('video');
  
      if (video) {
        // Hide controls initially
        video.controls = false;
  
        // Show controls on hover
        container.addEventListener('mouseenter', () => {
          video.controls = true;
        });
  
        // Hide controls when not hovering
        container.addEventListener('mouseleave', () => {
          video.controls = false;
        });
      }
    });
  });
  
  
  
  document.addEventListener("DOMContentLoaded", function () {
    // Check if the body has the 'cat-throne' class
    if (!document.body.classList.contains("cat-throne")) {
      return; // Exit if the class is not present
    }
  
    const thumbsContainer = document.querySelector(".thumbs-swiper .swiper-wrapper");
    const mainContainer = document.querySelector(".main-swiper .swiper-wrapper");
  
    // Check if containers exist
    if (!thumbsContainer || !mainContainer) {
      console.error("Thumbs or Main Swiper container is missing in the DOM.");
      return; // Exit if elements are not found
    }
  
    const thumbsSlides = thumbsContainer.children.length;
    const mainSlides = mainContainer.children.length;
  
    // Initialize the thumbs swiper
    const thumbsSwiper = new Swiper(".thumbs-swiper", {
      direction: "vertical",
      slidesPerView: 4.5,
      spaceBetween: 10,
      loop: false,
      freeMode: true,
      watchSlidesProgress: true,
      mousewheel: true,
      breakpoints: {
        768: {
          direction: "vertical",
        },
        0: {
          direction: "horizontal",
          slidesPerView: 2,
        },
      },
    });
  
    // Initialize the main swiper
    const mainSwiper = new Swiper(".main-swiper", {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 1,
      thumbs: {
        swiper: thumbsSwiper,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // autoplay: {
      //   delay: 6000,
      //   disableOnInteraction: false,
      // },
      breakpoints: {
        // Disable autoplay for screens >= 768px
        768: {
          autoplay: false,
        },
      },
    });

        //Ak custom code
     const selected_var = document.querySelector('.product-content-colors-varient.selected');
    if(selected_var){
        const variantId = selected_var.getAttribute("variant-id");
        selected_var.click();

                const variantImageSrc = selected_var.querySelector('.variant-image') ? selected_var.querySelector('.variant-image').src : null;
        
        if (variantImageSrc) {
          const variantImageFileName = variantImageSrc.substring(variantImageSrc.lastIndexOf('/') + 1).split('?')[0]; // Extract file name
  
          // Loop through each swiper thumbnail and check for a match based on the file name
          const swiperThumbs = thumbsContainer.querySelectorAll('.swiper-slide img');
          swiperThumbs.forEach(function(img) {
            const swiperImageSrc = img.src;
            const swiperImageFileName = swiperImageSrc.substring(swiperImageSrc.lastIndexOf('/') + 1).split('?')[0]; // Extract file name
  
            if (swiperImageFileName === variantImageFileName) {
              // Remove active classes from all thumbnails
              const swiperSlides = img.closest('.swiper-wrapper').querySelectorAll('.swiper-slide');
              swiperSlides.forEach(slide => {
                slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
              });
  
              // Add the 'swiper-slide-active' and 'swiper-slide-thumb-active' classes to the matching thumb
              const thumbSlide = img.closest('.swiper-slide');
              thumbSlide.classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
  
              // Update the main swiper image
              mainSwiper.slideTo(Array.from(swiperThumbs).indexOf(img)); // Sync main image with selected thumb
            }
          });
        }
    }
    //End Ak custom code
  
    // Function to update the list items based on the active slide
    function updateListItems() {
      const parentDiv = document.querySelector(".product-info-left-side");
  
      if (parentDiv) {
        const index = mainSwiper.activeIndex;
  
        const activeSlides = parentDiv.querySelectorAll(".swiper-slide");
  
        activeSlides.forEach((activeSlide) => {
          const ul = activeSlide.querySelector(".metafield-rich_text_field ul");
  
          if (ul) {
            const listItems = ul.querySelectorAll("li");
            listItems.forEach((li) => {
              li.style.display = "none";
            });
  
            if (listItems[index]) {
              listItems[index].style.display = "block";
            }
          }
        });
      }
    }
  
    // Run the function initially
    updateListItems();
  
    // Re-run the function when Swiper slide changes
    mainSwiper.on("slideChange", function () {
      updateListItems();
    });
  
    // Watch for the variant selection (both color and title variants)
    const variantElements = document.querySelectorAll('.product-content-variant-title, .product-content-colors-varient');
    variantElements.forEach(function(element) {
      element.addEventListener('click', function() {
        const selectedVariant = element;
        const variantImageSrc = selectedVariant.querySelector('.variant-image') ? selectedVariant.querySelector('.variant-image').src : null;
        
        if (variantImageSrc) {
          const variantImageFileName = variantImageSrc.substring(variantImageSrc.lastIndexOf('/') + 1).split('?')[0]; // Extract file name
  
          // Loop through each swiper thumbnail and check for a match based on the file name
          const swiperThumbs = thumbsContainer.querySelectorAll('.swiper-slide img');
          swiperThumbs.forEach(function(img) {
            const swiperImageSrc = img.src;
            const swiperImageFileName = swiperImageSrc.substring(swiperImageSrc.lastIndexOf('/') + 1).split('?')[0]; // Extract file name
  
            if (swiperImageFileName === variantImageFileName) {
              // Remove active classes from all thumbnails
              const swiperSlides = img.closest('.swiper-wrapper').querySelectorAll('.swiper-slide');
              swiperSlides.forEach(slide => {
                slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
              });
  
              // Add the 'swiper-slide-active' and 'swiper-slide-thumb-active' classes to the matching thumb
              const thumbSlide = img.closest('.swiper-slide');
              thumbSlide.classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
  
              // Update the main swiper image
              mainSwiper.slideTo(Array.from(swiperThumbs).indexOf(img)); // Sync main image with selected thumb
            }
          });
        }
      });
    });
  
    // Handle image click for toilet images with 'active' class
    const toiletImagesContainer = document.querySelector(".product-content-toilet-img");
  
    if (toiletImagesContainer) {
      toiletImagesContainer.addEventListener("click", function(event) {
        const clickedImage = event.target;
  
        // Check if the clicked image has the 'active' class
        if (clickedImage.classList.contains("active")) {
          const variantDataImgSrc = clickedImage.getAttribute("variant_data_img_src");
  
          if (variantDataImgSrc) {
            // Loop through each swiper thumbnail and match based on variant_data_img_src
            const swiperThumbs = thumbsContainer.querySelectorAll('.swiper-slide img');
            swiperThumbs.forEach(function(img) {
              const swiperImageSrc = img.src;
  
              if (swiperImageSrc.includes(variantDataImgSrc)) {
                // Remove active classes from all thumbnails
                const swiperSlides = img.closest('.swiper-wrapper').querySelectorAll('.swiper-slide');
                swiperSlides.forEach(slide => {
                  slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
                });
  
                // Add the 'swiper-slide-active' and 'swiper-slide-thumb-active' classes to the matching thumb
                const thumbSlide = img.closest('.swiper-slide');
                thumbSlide.classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
  
                // Update the main swiper image
                mainSwiper.slideTo(Array.from(swiperThumbs).indexOf(img)); // Sync main image with selected thumb
              }
            });
          }
        }
      });
    }
  });
  
  
  // Get all quantity control groups
  const decBtns = document.querySelectorAll('.dec-btn');
  const incBtns = document.querySelectorAll('.inc-btn');
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const quantityFields = document.querySelectorAll('#quantity'); // Assuming multiple hidden quantity inputs
  const payInstallmentsLinks = document.querySelectorAll('.Pay-installments'); // Get the Pay installments link
  
  // Loop through each group
  quantityInputs.forEach((quantityInput, index) => {
    const decBtn = decBtns[index];
    const incBtn = incBtns[index];
    const quantityField = quantityFields[index]; // Hidden quantity input field for the same group
    const payInstallmentsLink = payInstallmentsLinks[index]; // Get the corresponding link
  
    // Get the min and max values for this input
    const minValue = parseInt(quantityInput.getAttribute('min'), 10);
    const maxValue = parseInt(quantityInput.getAttribute('max'), 10);
  
    // Decrease quantity
    decBtn.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue > minValue) {
        currentValue -= 1;
        quantityInput.value = currentValue;
        quantityInput.setAttribute('value', currentValue); // Update the value attribute
        quantityField.value = currentValue; // Update the hidden quantity input
        payInstallmentsLink.setAttribute('data-quantity', currentValue); // Update the data-quantity attribute
      }
    });
  
    // Increase quantity
    incBtn.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue < maxValue) {
        currentValue += 1;
        quantityInput.value = currentValue;
        quantityInput.setAttribute('value', currentValue); // Update the value attribute
        quantityField.value = currentValue; // Update the hidden quantity input
        payInstallmentsLink.setAttribute('data-quantity', currentValue); // Update the data-quantity attribute
      }
    });
  
    // Optionally, allow users to change the value by typing
    quantityInput.addEventListener('input', () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (isNaN(currentValue) || currentValue < minValue) {
        currentValue = minValue;
        quantityInput.value = currentValue;
        quantityInput.setAttribute('value', currentValue); // Update the value attribute
        quantityField.value = currentValue; // Update the hidden quantity input
        payInstallmentsLink.setAttribute('data-quantity', currentValue); // Update the data-quantity attribute
      } else if (currentValue > maxValue) {
        currentValue = maxValue;
        quantityInput.value = currentValue;
        quantityInput.setAttribute('value', currentValue); // Update the value attribute
        quantityField.value = currentValue; // Update the hidden quantity input
        payInstallmentsLink.setAttribute('data-quantity', currentValue); // Update the data-quantity attribute
      }
    });
  });
  
  
  
  
  const radioButtons = document.querySelectorAll('.shape-radio');
  const shapeTitleSpan = document.getElementById('selected-shape');
  const hiddenVariantInput = document.getElementById('variant-id');
  
  // Function to remove styles from all labels and add to the selected one
  function updateLabelStyles(selectedRadio) {
    radioButtons.forEach((radio) => {
      const label = radio.nextElementSibling;
      label.style.opacity = '0.5'; // Dim non-selected labels
    });
  
    const selectedLabel = selectedRadio.nextElementSibling;
    selectedLabel.style.opacity = '1'; // Full opacity for selected label
  }
  
  // Set initial styles based on the first checked radio
  radioButtons.forEach((radio) => {
    if (radio.checked) {
      shapeTitleSpan.textContent = radio.nextElementSibling.textContent;
      hiddenVariantInput.value = radio.value;
      updateLabelStyles(radio); // Highlight the initially selected label
    }
  
    // Update the displayed shape, hidden input, and label styles when a variant is selected
    radio.addEventListener('change', (event) => {
      shapeTitleSpan.textContent = event.target.nextElementSibling.textContent;
      hiddenVariantInput.value = event.target.value;
      updateLabelStyles(event.target); // Highlight the new selected label
    });
  });
  
  
  
  
  document.addEventListener('DOMContentLoaded', function () {
    const payInstallmentsLink = document.querySelector('.Pay-installments');
  
    if (payInstallmentsLink) {
      payInstallmentsLink.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default link behavior
  
        // Get variant ID and quantity from attributes
        const variantId = payInstallmentsLink.getAttribute('variant-id');
        const quantity = payInstallmentsLink.getAttribute('data-quantity') || 1;
  
        // Validate the variant ID
        if (!variantId) {
          alert('Variant ID is missing. Cannot add to cart.');
          return;
        }
  
        // Add product to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to add product to cart.');
            }
            return response.json();
          })
          .then(() => {
            // Redirect to checkout after successful addition
            window.location.href = '/checkout';
          })
          .catch(error => {
            console.error(error);
            alert('There was an issue adding the product to your cart.');
          });
      });
    }
  });
  
  